<template>
<div>

        <q-modal 
            maximized
        >
           <div class="param-container">
            <q-modal-layout>
                <q-toolbar slot="header">
                <q-toolbar-title>
                    Редактирование заказа
                </q-toolbar-title>
                <q-btn
                    color="green"
                    label="save"
                    @click="clickSave"
                />
                </q-toolbar>

                <div class="layout-padding">
                <h1>Modal</h1>

             
                </div>
                 <q-toolbar slot="footer" color="primary">
                        <q-toolbar-title>
                            Footer
                        </q-toolbar-title>
                </q-toolbar>
            </q-modal-layout>
          </div>  
        </q-modal>
   </div>

</template>
<script>
/* eslint-disable */
export default {
    name : 'editOrderDialog',
    props:{
            visible : {
                type: Boolean,
                requered: true,
            },
        },
    data(){
        return {
            q_visible : this.visible,
        }
    },
    methods : {
        clickSave() {
           eventBus.$emit('closeEditOrder');
        }
    },
    computed :{
        getVisible() {
            return this.q_visible;
        }
    }

}
</script>
<style <style lang="scss" scoped>
    .param-container {
        width : 400px;
    }
</style>
